"use strict";
var publishLast_1 = require('../operators/publishLast');
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return publishLast_1.publishLast()(this);
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/operator/publishLast.js
// module id = 3263
// module chunks = 0